/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { IntentSwagger } from 'src/luis/core/services/intents/intentSwagger';
import { createConversationFeatureStore } from 'src/luis/core/stores/conversationFeatureStore';
import { createFeatureStoreHouse } from 'src/luis/core/stores/featureStoreHouse';
import { createIntentStore } from 'src/luis/core/stores/intentStore';
import { FeatureSwagger } from 'src/luis/modules/features/types/FeatureSwagger';
import { isPhraseList } from 'src/luis/modules/features/utils/conversationFeatureUtils';

/**
 * Converts the intent swagger type to the store type.
 *
 * @param intent The swagger object from the api.
 * @param labelsCount Count of utterances inside the intent.
 * @returns The store object.
 */
export const intentSwaggerToIntentStore = (intent: IntentSwagger, labelsCount: number) => {
    const featureStoreHouse = createFeatureStoreHouse();
    if (intent.features) {
        intent.features.forEach((f: FeatureSwagger) => {
            const id = isPhraseList(f) ? f.featureId : f.modelId;
            const typeId = isPhraseList(f) ? 'feature' : 'model';
            const name = isPhraseList(f) ? f.featureName : f.modelName;
            featureStoreHouse.add(createConversationFeatureStore(id, { typeId, name, isRequired: false }));
        });
    }

    return createIntentStore(intent.id, { name: intent.name, labelsCount, featureStoreHouse });
};
